import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LookupTypeStoreState } from "../types/lookupType";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: LookupTypeStoreState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const lookuptypes = createSlice({
  name: "lookuptypes",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = lookuptypes.actions;

export const selectSearchValue = (state: {
  lookuptypes: LookupTypeStoreState;
}) => state?.lookuptypes?.searchValue;
export const selectIsActive = (state: { lookuptypes: LookupTypeStoreState }) =>
  state?.lookuptypes?.isActive;
export default lookuptypes.reducer;
